<template>
  <div class="Logo" @click.prevent="$router.push('/')">
    <h1 class="m-0">
      <img
        src="./../assets/logo.svg"
        alt="CoinTrackr - Cryptocurrency Portfolio Manager"
        class="Logo_Image img-fluid d-none d-md-inline hidden-xs-down"
        v-if="isBeta === false"
      />
      <img
        src="./../assets/logo-beta.svg"
        alt="CoinTrackr - Cryptocurrency Portfolio Manager"
        class="Logo_Image img-fluid d-none d-md-inline hidden-xs-down"
        v-if="isBeta === true"
      />
      <img
        src="./../assets/logo-small.svg"
        alt="CoinTrackr - Cryptocurrency Portfolio Manager"
        class="Logo_Image Logo_Image--Small img-fluid d-md-none"
        v-if="isBeta === false"
      />
      <img
        src="./../assets/logo-small-beta.svg"
        alt="CoinTrackr - Cryptocurrency Portfolio Manager"
        class="Logo_Image Logo_Image--Small img-fluid d-md-none"
        v-if="isBeta === true"
      />
    </h1>
  </div>
</template>

<script>
export default {
  name: "Logo",
  computed: {
    isBeta() {
      return (window.location.hostname || "").includes("beta.cointrackr.com");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/variables";
@import "~@/scss/_mixins";

.Logo {
  color: #454545;
  cursor: pointer;
  margin: 0;
  margin-bottom: 6px;
}

.Logo_Image {
  max-height: 40px;
  height: 40px;
  width: auto;

  &--Small {
    max-height: 62px;
    height: 62px;
    margin: 10px 0 0;
  }
}

.Logo__Text {
  font-size: 48px;
  font-weight: bold;
  display: block;
}
</style>
